import { z } from 'zod';

import { QUESTION_TYPE } from 'types/question.types';

import { BaseQuestionSchema, getOptionsSchema } from './BaseQuestionSchema';

/**
 * Form Data Structure (UI Format) (CheckboxFormInput):
 * {
 *   label: string,
 *   type: QUESTION_TYPE.CHECK,
 *   isRequired: boolean,
 *   options: Array<{ value: string }>,
 *   hasOtherOption: boolean
 * }
 *
 * Database Data Structure (CheckboxFormValues):
 * {
 *   label: string,
 *   type: QUESTION_TYPE.CHECK,
 *   isRequired: boolean,
 *   options: string[],
 *   hasOtherOption: boolean
 * }
 */

// Schema for form data with transform to DB format
export const CheckboxSchema = BaseQuestionSchema.extend({
  type: z.literal(QUESTION_TYPE.CHECK),
  options: getOptionsSchema(1, 'A checkbox question requires at least 1 option'),
  hasOtherOption: z.boolean()
});

export type CheckboxFormInput = z.input<typeof CheckboxSchema>; // Form values
export type CheckboxFormValues = z.infer<typeof CheckboxSchema>; // DB values

export const CHECKBOX_DEFAULTS: CheckboxFormValues = {
  label: '',
  type: QUESTION_TYPE.CHECK,
  isRequired: false,
  options: ['Option 1', 'Option 2'],
  hasOtherOption: false
};
